module.exports = __webpack_public_path__ + "img/Hawaii.1d29635a.png";